export const guideSteps = [
  {
    step: '01',
    title: '先冷静，确认你面对的是什么',
    desc: '判断争议属于产品质量、服务未履约、退款争议还是合同纠纷。类型不同，优先使用的渠道也不同。',
    tips: ['把问题写成一句话', '明确你最想要的解决结果'],
  },
  {
    step: '02',
    title: '第一时间固定证据',
    desc: '证据决定了后续所有协商的底气。越早留存，越难被事后否认或修改。',
    tips: ['合同与订单截图', '付款与聊天记录', '现场照片或视频'],
  },
  {
    step: '03',
    title: '用文字方式与对方沟通',
    desc: '尽量使用可留存的渠道沟通，并在信息中清楚写明你的诉求与期限，避免只靠口头约定。',
    tips: ['保留完整对话', '要求书面答复', '记录工单编号'],
  },
  {
    step: '04',
    title: '逐级升级反馈渠道',
    desc: '先与商家协商，协商不成再向平台、行业主管部门或消费者组织反映，必要时通过法律途径处理。',
    tips: ['平台内投诉', '主管部门反映', '保留受理凭证'],
  },
  {
    step: '05',
    title: '必要时寻求专业支持',
    desc: '涉及金额较大或法律关系复杂的，建议咨询专业人士，评估时间成本与胜诉可能性后再决定是否诉讼。',
    tips: ['评估成本收益', '注意时效', '理性预期'],
  },
];

export const evidenceChecklist = [
  '交易合同或服务协议（含附件与补充条款）',
  '付款凭证、转账记录或发票',
  '与对方的完整聊天记录或通话录音',
  '商品或服务的现场照片、视频',
  '商品包装、说明书、标签等实物信息',
  '对方的主体信息（名称、联系方式、地址）',
  '平台订单号、工单号及相关页面截图',
  '你已发出的投诉或反馈记录',
];

export const misconceptions = [
  {
    icon: 'ri-emotion-line',
    title: '情绪越激动越有效',
    desc: '沟通中保持清晰表达，把诉求和依据说清楚，往往比提高音量更容易推进问题解决。',
  },
  {
    icon: 'ri-record-circle-line',
    title: '口头承诺也算数',
    desc: '没有留痕的口头承诺，在后续争议中很难被引用。重要约定尽量落到文字或书面。',
  },
  {
    icon: 'ri-time-line',
    title: '拖着等对方主动',
    desc: '时间拖得越久，证据越容易丢失，部分主张还可能受到时效限制，尽早处理更稳妥。',
  },
  {
    icon: 'ri-scales-line',
    title: '一定要争一口气',
    desc: '明确自己的核心诉求，避免把精力消耗在与诉求无关的争论上，衡量成本后再决定投入程度。',
  },
];

export const channels = [
  { name: '与商家协商', scene: '争议初期、金额较小', speed: '较快', note: '优先使用，注意留痕' },
  { name: '平台内投诉', scene: '线上交易、平台内下单', speed: '中等', note: '可借助平台规则施压' },
  { name: '主管部门反映', scene: '涉及行业监管问题', speed: '中等', note: '需提供完整材料' },
  { name: '消费者组织调解', scene: '协商未果、争议明确', speed: '中等', note: '以调解为主，不强制' },
  { name: '法律途径', scene: '金额较大、责任清晰', speed: '较慢', note: '建议先做专业咨询' },
];